import { Button, Flex, Text, Wrap, WrapItem } from 'design-system';

export interface AttributeChipsProps {
  label: string;
  values: string[];
  // Multi-select per dimension: each click toggles that value in or out, so
  // e.g. two of a brand's three packagings can be active at once. Values in
  // one dimension OR together; dimensions AND together.
  selectedValues: string[];
  disabledValues: string[];
  onToggle: (value: string) => void;
}

// Presentational chip group for one attribute dimension: selected = filled,
// disabled = grayed (value absent under the other active selections). The
// group is an inline label + chips unit sized to its content, so the parent
// can flow several dimensions onto one line.
export const AttributeChips = ({ label, values, selectedValues, disabledValues, onToggle }: AttributeChipsProps) => {
  return (
    <Flex align='center' gap='7px'>
      <Text
        fontSize='10px'
        fontWeight='semibold'
        letterSpacing='0.08em'
        color='gray.500'
        textTransform='uppercase'
        whiteSpace='nowrap'>
        {label}
      </Text>
      <Wrap spacing='4px'>
        {values.map((value) => {
          const isSelected = selectedValues.includes(value);
          const isDisabled = !isSelected && disabledValues.includes(value);

          return (
            <WrapItem key={value}>
              <Button
                size='xs'
                h='22px'
                px='9px'
                fontSize='11px'
                borderRadius='full'
                fontWeight={isSelected ? 'semibold' : 'medium'}
                variant={isSelected ? 'solid' : 'outline'}
                colorScheme={isSelected ? 'red' : 'gray'}
                isDisabled={isDisabled}
                onClick={() => onToggle(value)}>
                {value}
              </Button>
            </WrapItem>
          );
        })}
      </Wrap>
    </Flex>
  );
};
